import { customerApi } from './customerApi';

import { setCredentials } from '../slices/authSlice';

interface ResetPasswordRequest {
  email: string;
}
interface ResetPasswordValidateRequest {
  token: string;
}
interface InvitationValidateRequest {
  token: string;
}

interface UpdatePasswordRequest {
  password: string;
  password_confirmation: string;
  token: string;
}

interface CreatePasswordRequest {
  password: string;
  password_confirmation: string;
  token: string;
}

export interface AuthResponse {
  access_token: string;
}

export interface MfaStatusResponse extends AuthResponse {
  status: string;
}

const authenticationApi = customerApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponse, LoginRequest>({
      query: (credentials) => {
        return {
          url: '/v1/authentication/token',
          credentials: 'include',
          method: 'POST',
          body: credentials
        };
      },
      onQueryStarted(_, { queryFulfilled, dispatch }) {
        queryFulfilled.then(({ data }) => {
          if (data) {
            dispatch(setCredentials(data));
          }
        });
      }
    }),
    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/v1/authentication/token',
        credentials: 'include',
        method: 'DELETE'
      })
    }),
    forgotPassword: builder.mutation<void, ResetPasswordRequest>({
      query: (params) => ({
        url: '/v1/authentication/passwords/forgot',
        method: 'POST',
        body: params
      })
    }),
    validateResetPasswordToken: builder.query<
      void,
      ResetPasswordValidateRequest
    >({
      query: ({ token }) => ({
        url: '/v1/authentication/passwords/validate_reset_token',
        credentials: 'include',
        params: { token }
      })
    }),
    validateInvitationToken: builder.query<void, InvitationValidateRequest>({
      query: ({ token }) => ({
        url: '/v1/authentication/invitations/validate',
        credentials: 'include',
        params: { token }
      })
    }),
    resetPassword: builder.mutation<void, UpdatePasswordRequest>({
      query: (params) => ({
        url: '/v1/authentication/passwords/reset',
        method: 'PUT',
        body: params
      })
    }),
    createPassword: builder.mutation<void, CreatePasswordRequest>({
      query: (params) => ({
        url: '/v1/authentication/invitations/accept',
        method: 'PUT',
        body: params
      })
    })
  }),
  overrideExisting: false
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useForgotPasswordMutation,
  useValidateResetPasswordTokenQuery,
  useResetPasswordMutation,
  useCreatePasswordMutation,
  useValidateInvitationTokenQuery
} = authenticationApi;
